module.exports = ".error-msg {\n  color: #a94442;\n  padding: 0 10px;\n  font-size: 14px;\n  text-align: left; }\n\n.fix-error-icon {\n  top: 27px; }\n"